export const sidebarPresent = () => window.innerWidth <= 1024
